export const baseUrl =
  window.location.hostname === "localhost"
    ? "https://cotozere.cnl.sk" //TODO dočasná test cesta
    : window.location.origin;

const agentList = ["hyperion", "solaris", "romulus", "meridian", "kronos", "endor", "aurora", "caprica", "abydos", "aurora", "server1", "server2"];

export const classrooms = [];
export const classroomByPath = {};

let agentsLoaded = false;

export async function loadAllAgents() {
  if (agentsLoaded) return;
  agentsLoaded = true;

  const agentDataMap = {};

  const requests = agentList.map((agentName) =>
    fetch(`${baseUrl}/${agentName}/rest/details`, { //`${baseUrl}/${agentName}/rest/details`
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: Math.random().toString(36).substr(2, 9),
        text: ""
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const agent = {
          name: data.agentName,
          path: data.agentPath,
          token: data.agentToken,
          agentAddress: data.agentAddress,
          agentType: data.agentType,
          agentUrl: `${baseUrl}/${agentName}`, //TODO dočasná adresa
        };

        agentDataMap[agentName] = agent;
      })
      .catch((err) => {})
  );

  await Promise.all(requests);

  agentList.forEach((agentName) => {
    const agent = agentDataMap[agentName];
    if (!agent) return;
    classrooms.push(agent);
    classroomByPath[agent.path] = agent;
  });
}